/**
 * Lädt verwandte Produkte und startet danach das Karussell.
 */
(() => {
  const SELECTOR = 'product-recommendations[data-coverax-pdp-related]';

  function loadRecs(el) {
    if (!el || el.dataset.coveraxRelatedLoaded === 'true') return;

    const productId = el.dataset.productId;
    const sectionId = el.dataset.sectionId;
    const baseUrl = el.dataset.url;
    if (!productId || !sectionId || !baseUrl) return;

    el.dataset.coveraxRelatedLoaded = 'true';

    const joiner = baseUrl.includes('?') ? '&' : '?';
    const url = `${baseUrl}${joiner}product_id=${productId}&section_id=${sectionId}`;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`Related recommendations failed: ${response.status}`);
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const source = doc.querySelector('product-recommendations');
        const nodes = source ? Array.from(source.childNodes) : [];
        const imported = nodes.map((node) => document.importNode(node, true));
        if (imported.length) {
          el.replaceChildren(...imported);
        }
        el.classList.add('product-recommendations--loaded');
        if (typeof window.coveraxDecodeVisibleEntities === 'function') {
          window.coveraxDecodeVisibleEntities(el);
        }

        const hasSlides = Boolean(el.querySelector('.kp-bs__slide, .grid__item'));
        const section = el.closest('.shopify-section');
        if (section && !hasSlides) {
          section.classList.add('coverax-pdp-related--empty');
        }

        el.querySelectorAll('kp-bestsellers').forEach((carousel) => {
          if (typeof carousel.sync === 'function') carousel.sync();
        });

        el.querySelectorAll('.coverax-pdp-related__accordion').forEach((details) => {
          if (details.dataset.coveraxRelatedToggleBound === 'true') return;
          details.dataset.coveraxRelatedToggleBound = 'true';
          details.addEventListener('toggle', () => {
            if (!details.open) return;
            details.querySelectorAll('kp-bestsellers').forEach((carousel) => {
              if (typeof carousel.sync === 'function') carousel.sync();
            });
          });
        });
      })
      .catch((error) => {
        console.error(error);
        el.classList.add('product-recommendations--loaded');
        el.closest('.shopify-section')?.classList.add('coverax-pdp-related--empty');
      });
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach(loadRecs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
